module.exports = __webpack_public_path__ + "img/unchecked2.6e88af84.png";